import { createSelector } from '../../shared';
import type { AppState, GroupsHubDataState } from '..';

export const getPendingRequestGroupsCount = createSelector<AppState, GroupsHubDataState, number>(
    'getGroupsNeedingUserActionCount',
    [(appState: AppState) => appState.data.groupsHubState],
    groupsHubState => {
        const entries = groupsHubState.ownedGroupsIds.map(
            key => groupsHubState.unifiedGroupsMap[key]
        );
        const count = entries.filter(group => group.pendingMembershipRequests > 0).length;
        return count > 0 ? count : undefined;
    }
);

export const getExpiringGroupsCount = createSelector<AppState, GroupsHubDataState, number>(
    'getGroupsNeedingUserActionCount',
    [(appState: AppState) => appState.data.groupsHubState],
    groupsHubState => {
        const entries = groupsHubState.ownedGroupsIds.map(
            key => groupsHubState.unifiedGroupsMap[key]
        );
        const count = entries.filter(group => group.isExpiring).length;
        return count > 0 ? count : undefined;
    }
);
